module.exports = __webpack_public_path__ + "static/media/metastasis.fe9a1519.svg";